import "./_form-page-section.scss";
import React from 'react';
import {Button, Icon, RequiredFieldsSubheader, UnderlinedHeader} from "../../../components";

interface FormPageSectionProps extends React.PropsWithChildren<any> {
    id: string;
    distributionStyle?: string;
    headerText?: string;
    headerIcon?: string;
    headerButtonIndex?: number;
    headerRightContent?: React.ReactNode;
    showRequiredLabel?: boolean;
    showDeleteButton?: boolean;
    onClickButton?: Function;
}

function FormPageSection({
                             id,
                             distributionStyle,
                             headerText = undefined,
                             headerIcon = undefined,
                             headerButtonIndex,
                             headerRightContent,
                             showRequiredLabel = false,
                             showDeleteButton = false,
                             onClickButton,
                             children
                         }: Readonly<FormPageSectionProps>) {

    const generateIcon = () => {
        if (headerIcon && headerIcon === 'heart') {
            return <img data-testid={"heart-icon"}
                        src={'/heart.png'}
                        alt={'heart icon'}
                        width={"18px"}
                        height={"18px"}
                        className={'heart'}/>
        } else if (headerIcon) {
            return <Icon name={headerIcon} className={headerIcon}/>
        }
    }

    return (
        <section aria-label="Form Page Section" className="form-page-section" id={id} data-testid={id}>
            {headerText &&
                <div className={"form-page-section-header " + distributionStyle}>

                    <UnderlinedHeader
                        leftAlignedContent={
                            <div className="section-title" data-testid={'section-title'}>
                                              <span className="title-label">
                                              <h4>{headerText}</h4>
                                                  {
                                                      generateIcon()
                                                  }
                                              </span>
                                {showRequiredLabel &&
                                    <RequiredFieldsSubheader/>
                                }
                            </div>
                        }
                        rightAlignedContent={
                            (headerRightContent || showDeleteButton) &&
                            <div className="form-page-section-header-actions">
                                {headerRightContent}
                                {showDeleteButton &&
                                    <Button
                                        data-testid={"delete-button-" + headerButtonIndex}
                                        className={"delete-button"}
                                        onClick={() => {
                                            if (onClickButton !== undefined) {
                                                onClickButton()
                                            }
                                        }}
                                        icon="left"
                                        iconName={"delete"}
                                        kind="borderless"
                                        style={
                                            {
                                                "color": "#3D4042",
                                                "cursor": "pointer",
                                                "minWidth": "40px"
                                            }
                                        }/>
                                }
                            </div>
                        }
                    />


                </div>
            }
            <div className="form-page-section-body">
                {children}
            </div>
        </section>
    )
        ;
}

export default FormPageSection;